import { render } from "./SupportTicketManager.vue?vue&type=template&id=8e5488b4&scoped=true"
import script from "./SupportTicketManager.vue?vue&type=script&lang=js"
export * from "./SupportTicketManager.vue?vue&type=script&lang=js"

import "./SupportTicketManager.vue?vue&type=style&index=0&id=8e5488b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e5488b4"]])

export default __exports__